import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

export function isGuest() {
  return !LocalStorage.get(LocalStorageKey.PHONE_NUMBER)
}
